import React, { useEffect, useRef, useState } from "react";
import { Html5QrcodeScanType, Html5QrcodeScanner } from "html5-qrcode";
import "../css/QrScannerModal.css";
import Modal from "./Modal";

const QrScannerModal = ({ open, handleClose, onScanSuccess }) => {
  const readerRef = useRef(null);
  const [scanner, setScanner] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const resetScanner = async () => {
    if (scanner) {
      try {
        await scanner.clear();
        await new Promise(resolve => setTimeout(resolve, 0));
        setScanner(null);
        setErrorMessage("");
      } catch (err) {
        console.error("Error clearing scanner:", err);
        setErrorMessage("Error clearing scanner");
      }
    }
  };

  const validateQRCode = (text) => {
    const regex = /^[A-Z0-9]{10}$/;
    return regex.test(text);
  };

  useEffect(() => {
    if (open && readerRef.current) {
      const config = {
        fps: 10,
        qrbox: { width: 200, height: 200 },
        rememberLastUsedCamera: true,
        supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
      };

      const newScanner = new Html5QrcodeScanner("reader", config);
      setScanner(newScanner);

      newScanner.render(
        (text) => {
          if (validateQRCode(text)) {
            onScanSuccess(text);
            newScanner
              .clear()
              .then(() => {
                setScanner(null);
                setErrorMessage("");
                handleClose();
              })
              .catch((err) => console.error("Error stopping scanner:", err));
          } else {
            setErrorMessage("Invalid QR Code format. Please scan again.");
          }
        },
        (error) => {
          console.error("QR Code Scan Error:", error);
        }
      );
    }

    return () => {
      const runResetScanner = async () => {
        await resetScanner();
      };
      runResetScanner();
    };
  }, [open, onScanSuccess, handleClose]);

  return (
    <Modal
      isOpen={open}
      onClose={() => {
        resetScanner();
        handleClose();
      }}
    >
      <div className="modal-container" data-testid="qr-scanner-modal">
        <button
          className="qr-close-icon"
          onClick={() => {
            resetScanner();
            handleClose();
          }}
          data-testid="qr-close-button"
        >
          &times;
        </button>
        <h2>Scan</h2>
        <div id="reader" ref={readerRef} className="reader" data-testid="qr-scanner-reader"></div>
        {errorMessage && (
          <p className="error-message" data-testid="error-message">
            {errorMessage}
          </p>
        )}

        <p data-testid="qr-instructions">{"Point your camera at a QR code"}</p>
      </div>
    </Modal>
  );
};

export default QrScannerModal;
